export const IMGCDNDOMAIN = "//image1.ljcdn.com";

export const VIDEO_CDN_DOMIN = "//video.ljcdn.com";

export function getCookie(name) {
  let allCookie = decodeURIComponent(document.cookie);
  let ifHave = allCookie.indexOf(name);
  if (ifHave === -1) {
    return null;
  } else {
    let cookieArr = allCookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      let keys = cookieArr[i].split("=");
      if (keys[0].trim() === name) {
        return keys[1];
      }
    }
  }
}

// 版本号比较
export const versionCompare = ver1 => {
  return {
    gte: ver2 => {
      if (ver1 === ver2) return true;
      if (!ver1 && ver1 !== 0) return false;
      if (!ver2 && ver2 !== 0) return true;

      const _patch = "..........";
      const _paddedVer1 = (ver1 + _patch)
        .split(/[-.]/)
        .slice(0, 10)
        .map(v => ("00000" + v).slice(-5))
        .join("");
      const _paddedVer2 = (ver2 + _patch)
        .split(/[-.]/)
        .slice(0, 10)
        .map(v => ("00000" + v).slice(-5))
        .join("");
      return _paddedVer1 >= _paddedVer2;
    }
  };
};

// 数组和对象的深拷贝
export const deepCopy = obj => {
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        result[key] = deepCopy(obj[key]); //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
};

// 将对象转换为url请求参数，并过滤不存在的值
export const objToQueryStr = obj => {
  const ret = [];
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "")
      continue;
    ret.push(`${key}=${encodeURIComponent(obj[key])}`);
  }
  return ret.join("&");
};
// 获取url参数，返回对象
export const getUrlParamsObj = () => {
  const search = window.location.search;
  const obj = {};
  const params = search.substring(1).split("&");

  params.forEach(pair => {
    const kv = pair.split("=");
    obj[kv[0]] = kv[1];
  });

  return obj;
}

// 获取url参数，返回对象
export const getSearchByObj = (obj) => {
  if(typeof obj !== 'object' || !obj) {
    return "";
  }

  let result = "?";
  const keys = Object.keys(obj);

  keys.forEach((each, i) => {
    result = result
      .concat(each)
      .concat("=")
      .concat(obj[each]);

    if (i !== keys.length - 1) {
      result = result.concat("&");
    }
  });

  return result;
}

/**
 * 比较手机版本
 * version1<version2 return -1
 * version1=version2 return 0
 * version1>version2 return 1
 */
export const compareAppVersion = (version1, version2) => {
  const arr1 = version1.split(".");
  const arr2 = version2.split(".");
  const length1 = arr1.length;
  const length2 = arr2.length;
  const minlength = Math.min(length1, length2);
  let i = 0;
  for (i; i < minlength; i++) {
    let a = parseInt(arr1[i]);
    let b = parseInt(arr2[i]);
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
  }
  if (length1 > length2) {
    for (let j = i; j < length1; j++) {
      if (parseInt(arr1[j]) != 0) {
        return 1;
      }
    }
    return 0;
  } else if (length1 < length2) {
    for (let j = i; j < length2; j++) {
      if (parseInt(arr2[j]) != 0) {
        return -1;
      }
    }
    return 0;
  }
  return 0;
};

/**
 * 与原生 app 通信
 * @param {"callNativeSelectVideo" | "callNativeTakeVideo"} actionUrl
 * @returns {Promise<String>}
 */
export const commFromNativeAppByActionUrl = actionUrl => {
  return new Promise(resolve => {
    const callbackId = Math.random()
      .toString(36)
      .slice(2);
    const functionName = `callback_${actionUrl}_$${callbackId}`;
    window[functionName] = value => {
      resolve(value);
      window[functionName] = null;
    };
    window.$ljBridge.ready((bridge, webstatus) => {
      const jsonStr = JSON.stringify({
        actionUrl,
        functionName
      });
      bridge.callAndBack(jsonStr);
    });
  });
};
